export default function SpecialCharactersSmiley( editor ) {
    editor.plugins.get( 'SpecialCharacters' ).addItems( 'Smiley', [
        { title: 'smiley grinning face', character: '😀' },
        { title: 'smiley grinning face with smiling eyes', character: '😄' },
        { title: 'smiley beaming face with smiling eyes', character: '😁' },
        { title: 'smiley grinning squinting face', character: '😆' },
        { title: 'smiley grinning face with sweat', character: '😅' },
        { title: 'smiley face with tears of joy', character: '😂' },
        { title: 'smiley rolling on the floor laughing', character: '🤣' },
        { title: 'smiley slightly smiling face', character: '🙂' },
        { title: 'smiley upside-down face', character: '🙃' },
        { title: 'smiley winking face', character: '😉' },
        { title: 'smiley smiling face with smiling eyes', character: '😊' },
        { title: 'smiley smiling face with halo', character: '😇' },
        { title: 'smiley smiling face with hearts', character: '🥰' },
        { title: 'smiley smiling face with heart-eyes', character: '😍' },
        { title: 'smiley star-struck', character: '🤩' },
        { title: 'smiley face blowing a kiss', character: '😘' },
        { title: 'smiley kissing face with smiling eyes', character: '😙' },
        { title: 'smiley smiling face with tear', character: '🥲' },
        { title: 'smiley face savoring food', character: '😋' },
        { title: 'smiley squinting face with tongue', character: '😝' },
        { title: 'smiley winking face with tongue', character: '😜' },
        { title: 'smiley zany face', character: '🤪' },
        { title: 'smiley money-mouth face', character: '🤑' },
        { title: 'smiley smiling face with open hands', character: '🤗' },
        { title: 'smiley face with hand over mouth', character: '🤭' },
        { title: 'smiley shushing face', character: '🤫' },
        { title: 'smiley thinking face', character: '🤔' },
        { title: 'smiley zipper-mouth face', character: '🤐' },
        { title: 'smiley face with raised eyebrow', character: '🤨' },
        { title: 'smiley expressionless face', character: '😑' },
        { title: 'smiley face without mouth', character: '😶' },
        { title: 'smiley face in clouds', character: '😶‍🌫️' },
        { title: 'smiley smirking face', character: '😏' },
        { title: 'smiley unamused face', character: '😒' },
        { title: 'smiley face with rolling eyes', character: '🙄' },
        { title: 'smiley grimacing face', character: '😬' },
        { title: 'smiley face exhaling', character: '😮‍💨' },
        { title: 'smiley lying face', character: '🤥' },
        { title: 'smiley relieved face', character: '😌' },
        { title: 'smiley pensive face', character: '😔' },
        { title: 'smiley sleepy face', character: '😪' },
        { title: 'smiley drooling face', character: '🤤' },
        { title: 'smiley sleeping face', character: '😴' },
        { title: 'smiley face with medical mask', character: '😷' },
        { title: 'smiley face with thermometer', character: '🤒' },
        { title: 'smiley face with head-bandage', character: '🤕' },
        { title: 'smiley nauseated face', character: '🤢' },
        { title: 'smiley face vomiting', character: '🤮' },
        { title: 'smiley sneezing face', character: '🤧' },
        { title: 'smiley hot face', character: '🥵' },
        { title: 'smiley cold face', character: '🥶' },
        { title: 'smiley woozy face', character: '🥴' },
        { title: 'smiley face with crossed-out eyes', character: '😵' },
        { title: 'smiley face with spiral eyes', character: '😵‍💫' },
        { title: 'smiley exploding head', character: '🤯' },
        { title: 'smiley cowboy hat face', character: '🤠' },
        { title: 'smiley partying face', character: '🥳' },
        { title: 'smiley disguised face', character: '🥸' },
        { title: 'smiley smiling face with sunglasses', character: '😎' },
        { title: 'smiley nerd face', character: '🤓' },
        { title: 'smiley face with monocle', character: '🧐' },
        { title: 'smiley confused face', character: '😕' },
        { title: 'smiley worried face', character: '😟' },
        { title: 'smiley slightly frowning face', character: '🙁' },
        { title: 'smiley frowning face', character: '☹️' },
        { title: 'smiley face with open mouth', character: '😮' },
        { title: 'smiley hushed face', character: '😯' },
        { title: 'smiley astonished face', character: '😲' },
        { title: 'smiley flushed face', character: '😳' },
        { title: 'smiley pleading face', character: '🥺' },
        { title: 'smiley anguished face', character: '😧' },
        { title: 'smiley fearful face', character: '😨' },
        { title: 'smiley anxious face with sweat', character: '😰' },
        { title: 'smiley sad but relieved face', character: '😥' },
        { title: 'smiley crying face', character: '😢' },
        { title: 'smiley loudly crying face', character: '😭' },
        { title: 'smiley face screaming in fear', character: '😱' },
        { title: 'smiley confounded face', character: '😖' },
        { title: 'smiley persevering face', character: '😣' },
        { title: 'smiley disappointed face', character: '😞' },
        { title: 'smiley downcast face with sweat', character: '😓' },
        { title: 'smiley weary face', character: '😩' },
        { title: 'smiley tired face', character: '😫' },
        { title: 'smiley yawning face', character: '🥱' },
        { title: 'smiley face with steam from nose', character: '😤' },
        { title: 'smiley angry face', character: '😡' },
        { title: 'smiley face with symbols on mouth', character: '🤬' },
    ] );
}
